import { UserRole } from '../../shared/model/role';
import { IPageSelector } from './navigation.model';

function getRole(): UserRole {
    const roleStr = localStorage.getItem('userRole');
    return roleStr as UserRole || UserRole.USER;
}

export function NAVIGATION(): IPageSelector[] {
    let role = getRole();

    // =========================================================
    // SUPER ADMIN NAVIGATION
    // =========================================================
    if (role === UserRole.SUPERADMIN) {
        return [
            {
                label: 'Dashboard',
                route: 'superAdmin/dashboard',
                roles: [UserRole.SUPERADMIN],
                children: [
                    {
                        label: 'Overview',
                        route: '/superAdmin/dashboard/overview',
                        roles: [UserRole.SUPERADMIN],
                    },
                ],
            },
            {
                label: 'Organizations',
                route: 'superAdmin/organizations',
                roles: [UserRole.SUPERADMIN],
                children: [
                    {
                        label: 'Overview',
                        route: '/superAdmin/organizations/overview',
                        roles: [UserRole.SUPERADMIN],
                    },
                    {
                        label: 'Plan & Quota',
                        route: '/superAdmin/organizations/plan-quota',
                        roles: [UserRole.SUPERADMIN],
                        queryParamsHandling: 'merge',
                    },
                    {
                        label: 'Licenses',
                        route: '/superAdmin/organizations/licenses',
                        roles: [UserRole.SUPERADMIN],
                        queryParamsHandling: 'merge',
                    },

                    {
                        label: 'Admins',
                        route: '/superAdmin/organizations/administrators',
                        roles: [UserRole.SUPERADMIN],
                        queryParamsHandling: 'merge',
                    },
                ],
            },
            {
                label: 'Configuration',
                route: 'superAdmin/configurations',
                roles: [UserRole.SUPERADMIN],
                children: [
                    {
                        label: 'Release',
                        route: '/superAdmin/configurations/releases',
                        roles: [UserRole.SUPERADMIN],
                    },
                    {
                        label: 'Threat Categories',
                        route: '/superAdmin/configurations/threat-categories',
                        roles: [UserRole.SUPERADMIN],
                    },
                    {
                        label: 'Pricing Tiers',
                        route: '/superAdmin/configurations/pricing-tiers',
                        roles: [UserRole.SUPERADMIN],
                    },
                    {
                        label: 'Settings',
                        route: '/superAdmin/configurations/settings',
                        roles: [UserRole.SUPERADMIN],
                    },
                ],
            },
        ];
    }


    return [
        {
            label: 'Dashboard',
            route: `${role}/dashboard`,
            roles: [
                UserRole.ADMIN,
                UserRole.TEAMMANAGER,
                UserRole.USER,
                UserRole.VIEWER
            ],
            children: [
                {
                    label: 'Overview',
                    route: `/${role}/dashboard/overview`,
                    roles: [
                        UserRole.ADMIN,
                        UserRole.TEAMMANAGER,
                        UserRole.USER,
                        UserRole.VIEWER
                    ]
                },

            ]
        },

        {
            label: 'Security',
            route: `${role}/security`,
            roles: [
                UserRole.ADMIN, UserRole.TEAMMANAGER,

            ],
            children: [
                {
                    label: 'Security Policy',
                    route: `/${role}/security/security-policy`,
                    roles: [UserRole.ADMIN]
                },
                {
                    label: 'Packages',
                    route: `/${role}/security/packages`,
                    roles: [UserRole.ADMIN, UserRole.TEAMMANAGER]
                },
                {
                    label: 'Threats',
                    route: `/${role}/security/threats`,
                    roles: [UserRole.ADMIN]
                },
                {
                    label: 'Scan History',
                    route: `/${role}/security/scanHistory`,
                    roles: [UserRole.ADMIN]
                }
            ]
        },

        // {
        //     label: 'Super Admin',
        //     route: 'super-admin',
        //     roles: [
        //         UserRole.ADMIN,
        //         UserRole.TEAMMANAGER,
        //         UserRole.USER,
        //         UserRole.VIEWER
        //     ],
        //     children: [
        //         {
        //             label: 'Dashboard',
        //             route: 'dashboard',
        //             roles: [UserRole.SUPERADMIN]
        //         },
        //         {
        //             label: 'Organizations',
        //             route: 'organizations',
        //             roles: [UserRole.SUPERADMIN]
        //         },
        //         {
        //             label: 'Release',
        //             route: 'release',
        //             roles: [UserRole.SUPERADMIN]
        //         },
        //         {
        //             label: 'Pricing Tiers',
        //             route: 'pricing-tiers',
        //             roles: [UserRole.SUPERADMIN]
        //         },
        //         {
        //             label: 'Settings',
        //             route: 'settings',
        //             roles: [UserRole.SUPERADMIN]
        //         }
        //     ]
        // },

        {
            label: 'Activity',
            route: `${role}/activity`,
            roles: [
                UserRole.ADMIN,
                UserRole.TEAMMANAGER,

            ],
            children: [
                {
                    label: 'Download Log',
                    route: `/${role}/activity/downloadLogs`,
                    roles: [UserRole.ADMIN, UserRole.TEAMMANAGER]
                },
                {
                    label: 'Audit Logs',
                    route: `/${role}/activity/auditLogs`,
                    roles: [UserRole.ADMIN]
                }

            ]
        },

        {
            label: 'Access',
            route: `${role}/access`,
            roles: [
                UserRole.ADMIN,
                // UserRole.TEAMMANAGER,
                // UserRole.USER,
                // UserRole.VIEWER
            ],
            children: [
                {
                    label: 'Teams',
                    route: `/${role}/access/teams`,
                    roles: [UserRole.ADMIN]
                },
                {
                    label: 'Users',
                    route: `/${role}/access/users`,
                    roles: [UserRole.ADMIN]
                },
                {
                    label: 'Devices',
                    route: `/${role}/access/devices`,
                    roles: [UserRole.ADMIN]
                }

            ]
        },

        {
            label: 'Integrations',
            route: `${role}/integrations`,
            roles: [
                UserRole.ADMIN,

            ],
            children: [
                {
                    label: 'Repositories',
                    route: `/${role}/integrations/repositories`,
                    roles: [UserRole.ADMIN]
                },
                {
                    label: 'Deployment Keys',
                    route: `/${role}/integrations/deploymentKeys`,
                    roles: [UserRole.ADMIN]
                },
            ]
        }
    ]
}


// import { UserRole } from '../../shared/model/role';
// import { IPageSelector } from './navigation.model';

// function getRole(): UserRole {
//     const roleStr = localStorage.getItem('userRole');
//     return roleStr as UserRole || UserRole.USER;
// }

// export function NAVIGATION(): IPageSelector[] {

//     const role = getRole();

//     // =========================================================
//     // SUPER ADMIN NAVIGATION
//     // =========================================================
//     // if (role === UserRole.SUPERADMIN) {

//     //     return [
//     //         {
//     //             label: 'Dashboard',
//     //             route: '/superAdmin/dashboard',
//     //             roles: [UserRole.SUPERADMIN],
//     //             children: [
//     //                 {
//     //                     label: 'Overview',
//     //                     route: '/superAdmin/dashboard/overview',
//     //                     roles: [UserRole.SUPERADMIN]
//     //                 }
//     //             ]
//     //         },
//     //         {
//     //         label: 'Super Admin',
//     //         route: '/superAdmin',
//     //         roles: [
//     //             UserRole.SUPERADMIN
//     //         ],
//     //         children: [
//     //             // {
//     //             //     label: 'Dashboard',
//     //             //     route: '/superAdmin/dashboard',
//     //             //     roles: [UserRole.SUPERADMIN]
//     //             // },

//     //             {
//     //                 label: 'Organizations',
//     //                 route: '/superAdmin/organizations',
//     //                 roles: [UserRole.SUPERADMIN]
//     //             },

//     //             {
//     //                 label: 'Release',
//     //                 route: '/superAdmin/release',
//     //                 roles: [UserRole.SUPERADMIN]
//     //             },

//     //             {
//     //                 label: 'Pricing Tiers',
//     //                 route: '/superAdmin/pricing-tiers',
//     //                 roles: [UserRole.SUPERADMIN]
//     //             },

//     //             {
//     //                 label: 'Settings',
//     //                 route: '/superAdmin/settings',
//     //                 roles: [UserRole.SUPERADMIN]
//     //             }
//     //         ]
//     //     },
//     //     ]

//     // }


//     // =========================================================
//     // NORMAL USER NAVIGATION
//     // =========================================================

//     return [

//         // -----------------------------------------------------
//         // Dashboard
//         // -----------------------------------------------------
//         {
//             label: 'Dashboard',
//             route: `/${role}/dashboard`,
//             roles: [
//                 UserRole.ADMIN,
//                 UserRole.TEAMMANAGER,
//                 UserRole.USER,
//                 UserRole.VIEWER
//             ],
//             children: [
//                 {
//                     label: 'Overview',
//                     route: `/${role}/dashboard/overview`,
//                     roles: [
//                         UserRole.ADMIN,
//                         UserRole.TEAMMANAGER,
//                         UserRole.USER,
//                         UserRole.VIEWER
//                     ]
//                 }
//             ]
//         },


//         // -----------------------------------------------------
//         // Security
//         // -----------------------------------------------------
//         {
//             label: 'Security',
//             route: `/${role}/security`,
//             roles: [
//                 UserRole.ADMIN,
//                 UserRole.TEAMMANAGER,
//                 UserRole.USER,
//                 UserRole.VIEWER
//             ],
//             children: [
//                 {
//                     label: 'Packages',
//                     route: `/${role}/security/packages`,
//                     roles: [UserRole.ADMIN]
//                 },

//                 {
//                     label: 'Threats',
//                     route: `/${role}/security/threats`,
//                     roles: [UserRole.ADMIN]
//                 },

//                 {
//                     label: 'Scan History',
//                     route: `/${role}/security/scanHistory`,
//                     roles: [UserRole.ADMIN]
//                 }
//             ]
//         },


//         // -----------------------------------------------------
//         // Activity
//         // -----------------------------------------------------
//         {
//             label: 'Activity',
//             route: `/${role}/activity`,
//             roles: [
//                 UserRole.ADMIN,
//                 UserRole.TEAMMANAGER,
//                 UserRole.USER,
//                 UserRole.VIEWER
//             ],
//             children: [
//                 {
//                     label: 'Download Log',
//                     route: `/${role}/activity/downloadLogs`,
//                     roles: [
//                         UserRole.ADMIN,
//                         UserRole.TEAMMANAGER
//                     ]
//                 },

//                 {
//                     label: 'Audit Logs',
//                     route: `/${role}/activity/auditLogs`,
//                     roles: [UserRole.ADMIN]
//                 }
//             ]
//         },


//         // -----------------------------------------------------
//         // Access
//         // -----------------------------------------------------
//         {
//             label: 'Access',
//             route: `/${role}/access`,
//             roles: [
//                 UserRole.ADMIN,
//                 UserRole.TEAMMANAGER,
//                 UserRole.USER,
//                 UserRole.VIEWER
//             ],
//             children: [
//                 {
//                     label: 'Teams',
//                     route: `/${role}/access/teams`,
//                     roles: [UserRole.ADMIN]
//                 },

//                 {
//                     label: 'Users',
//                     route: `/${role}/access/users`,
//                     roles: [UserRole.ADMIN]
//                 },

//                 {
//                     label: 'Devices',
//                     route: `/${role}/access/devices`,
//                     roles: [UserRole.ADMIN]
//                 }
//             ]
//         },


//         // -----------------------------------------------------
//         // Integrations
//         // -----------------------------------------------------
//         {
//             label: 'Integrations',
//             route: `/${role}/integrations`,
//             roles: [
//                 UserRole.ADMIN,
//                 UserRole.TEAMMANAGER,
//                 UserRole.USER,
//                 UserRole.VIEWER
//             ],
//             children: [
//                 {
//                     label: 'Repositories',
//                     route: `/${role}/integrations/repositories`,
//                     roles: [UserRole.ADMIN]
//                 },

//                 {
//                     label: 'Deployment Keys',
//                     route: `/${role}/integrations/deploymentKeys`,
//                     roles: [UserRole.ADMIN]
//                 }
//             ]
//         }
//     ];
// }
